/**
 * 写在前端的options，集中管理
 */
export const logics = ["=", ">=", ">", "<=", "<"];

export const statuss = [
  // { id: 1, value: "待分配规划师" },
  {id: 1, value: "待分配", type: "danger"},
  {id: 2, value: "待处理", type: "warning"},
  {id: 3, value: "服务中", type: "info"},
  {id: 4, value: "已完成", type: "success"},
  {id: 6, value: "已暂停", type: ""},
  {id: 7, value: "已退费", type: ""},
];